import { createCrud } from '@lumahealthhq/ui-model';
import { EModel } from '@lumahealthhq/ui-model-types';
import { getModelBasePath } from '@lumahealthhq/ui-utils';
var basePath = getModelBasePath(EModel.Assistant);
var crud = createCrud(basePath);

/* Default queries */
export var useAssistantCount = crud.makeCount();
export var useAssistantById = crud.makeFindById();
export var useAssistantByIds = crud.makeFindByIds();
export var useAssistantMany = crud.makeFindMany();
export var useAssistantOne = crud.makeFindOne();
export var useAssistantPagination = crud.makePagination();

/* Default mutations */
export var useAssistantCreateOne = crud.makeCreateOne();
export var useAssistantUpdateOne = crud.makeUpdateOne();
export var useAssistantRemoveById = crud.makeRemoveById();